import React from 'react';
import {
  StyledFormItemContainer,
  StyledLabel,
  StyledInputWrapper,
} from './index.styled';

export interface AppFormItemProps {
  label?: string;
  required?: boolean;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  htmlFor?: string;
  labelPosition?: 'top' | 'left';
  justifyContent?: 'space-between' | 'flex-start';
}

const AppFormItem: React.FC<AppFormItemProps> = ({
  label,
  required = false,
  children,
  className,
  style,
  htmlFor,
  labelPosition = 'left',
  justifyContent = 'space-between',
  ...rest
}) => {
  return (
    <StyledFormItemContainer
      className={className}
      style={style}
      labelPosition={labelPosition}
      justifyContent={justifyContent}
      {...rest}
    >
      {label && (
        <StyledLabel required={required} htmlFor={htmlFor}>
          {label}
        </StyledLabel>
      )}
      <StyledInputWrapper labelPosition={labelPosition}>
        {children}
      </StyledInputWrapper>
    </StyledFormItemContainer>
  );
};

export default AppFormItem;
